import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

const TTL_MS = 5 * 60 * 1000; // 5 minutes

interface CacheEntry<T> {
  data: T;
  ts: number;
}

const cache: Record<string, CacheEntry<any>> = {};

function getCached<T>(key: string): T | null {
  const entry = cache[key];
  if (entry && Date.now() - entry.ts < TTL_MS) return entry.data as T;
  return null;
}

function setCached<T>(key: string, data: T): T {
  cache[key] = { data, ts: Date.now() };
  return data;
}

export const mondayService = {
  async getEligibleEmployees(): Promise<{ configured: boolean; sagi: number; ariel: number; total: number; sagiItems: { name: string; count: number }[]; arielItems: { name: string; count: number }[] }> {
    const cached = getCached<{ configured: boolean; sagi: number; ariel: number; total: number; sagiItems: { name: string; count: number }[]; arielItems: { name: string; count: number }[] }>('eligibleEmployees');
    if (cached) return cached;
    const res = await api.get('/monday/eligible-employees');
    return setCached('eligibleEmployees', res.data);
  },
  async getBoards(): Promise<{ configured: boolean; boards: any[] }> {
    const cached = getCached<{ configured: boolean; boards: any[] }>('boards');
    if (cached) return cached;
    const res = await api.get('/monday/boards');
    return setCached('boards', res.data);
  },
};
